import type { IUpdateIssueCmd } from "@/data/commands/support/UpdateIssueCmd";
import { Factory } from "@/data/dao/Factory";
import { SupportDao } from "@/data/dao/service/SupportDao";
import { IssueState } from "@/data/model/Enums";
import type { IIssue } from "@/data/model/Support";
import { Misc } from "@/data/util/Misc";

import { BaseModal } from "@/shared/elements/BaseModal";
import { logError } from "@/shared/logging/errors";
import { style } from "@/shared/ui/Style";

import { i18n } from "@/portal/Trans";
import { Select } from "@/portal/formControls/Select";

export class SupportIssueWindow extends BaseModal {
    private $form: JQuery;
    private $submitBtn: JQuery;

    private stateSelect: Select<IssueState>;

    public onSaved?: { (newIssue: IIssue) };
    public onRemoved?: { () };
    private issue: IIssue;

    constructor(issue: IIssue) {
        super(i18n("modal.supportIssue.title"), "modal-lg", false);

        this.issue = issue;
        this.$element.addClass("supportissue");

        this.$form = $('<form class="kt-form kt-form--label-right" />').appendTo(this.$body);

        const section = $('<div class="kt-section kt-section--first"><div class="kt-section__body" /></div>')
            .appendTo(this.$form)
            .find("> .kt-section__body");
        section.append(
            '<div class="row"><label class="col-xl-4"></label><div class="col-lg-9 col-xl-6"><h3 class="kt-section__title kt-section__title-sm">' +
                i18n("modal.supportIssue.editRequest") +
                "</h3></div></div>"
        );
        const container = $(
            '<div class="form-group row"><label class="col-xl-4 col-form-label">' +
                i18n("general.fields.state") +
                '</label><div class="col-xl-6" /></div>'
        )
            .appendTo(section)
            .find("> .col-xl-6");

        const select = $("<select />").appendTo(container);
        Misc.eachEnum(IssueState, (i, e) => {
            select.append('<option value="' + i + '">' + i18n("enums.IssueState." + e) + "</option>");
        });
        this.stateSelect = Select.createFromSelect(select);
        this.stateSelect.setValue(issue.state);

        const deleteBtn = $('<button class="btn btn-clean btn-small">' + i18n("general.delete") + "</button>")
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();

                deleteBtn
                    .addClass("kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--primary disabled")
                    .prop("disabled", true);
                Factory.getInstance<SupportDao>(SupportDao)
                    .removeIssue(issue.id)
                    .then(() => {
                        this.close();
                        if (this.onRemoved !== undefined) this.onRemoved();
                    })
                    .catch((ex) => {
                        logError(ex);
                        deleteBtn
                            .removeClass("kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--primary disabled")
                            .prop("disabled", false);
                        alert(i18n("modal.supportIssue.failedDelete"));
                    });
            });

        $('<button type="button" class="btn btn-secondary">' + i18n("general.cancel") + "</button>")
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();
                this.close();
            });

        this.$submitBtn = $('<button type="button" class="btn btn-success">' + i18n("general.save") + "</button>")
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();
                this.$form.submit();
            });

        this.$form.submit((e) => {
            e.preventDefault();
            e.stopPropagation();

            this.onSubmit();

            return false;
        });
    }

    protected onShow() {}

    protected onHide() {}

    private onSubmit() {
        const cmd: IUpdateIssueCmd = {
            state: parseInt(this.stateSelect.getValue()!),
        };

        this.$submitBtn.addClass(style.buttonLoaderClass).prop("disabled", true).find("> .la").remove();
        Factory.getInstance<SupportDao>(SupportDao)
            .updateIssue(this.issue.id, cmd)
            .then((m) => {
                this.$submitBtn.removeClass(style.buttonLoaderClass).prop("disabled", false);
                if (this.$submitBtn.find("> .la").length === 0) this.$submitBtn.prepend('<i class="la la-save" />');

                this.close();
                if (this.onSaved !== undefined) this.onSaved(m);
            })
            .catch((ex) => {
                logError(ex);
                this.$submitBtn.removeClass(style.buttonLoaderClass).prop("disabled", false);
                if (this.$submitBtn.find("> .la").length === 0) this.$submitBtn.prepend('<i class="la la-save" />');

                alert(i18n("modal.supportIssue.failedEdit"));
            });
    }
}
